import React from "react";
import { Undo } from "@mui/icons-material";

import { HistoryContext, useHistory } from "fond/history";
import { getHotkeyLabel, useHotkeys } from "fond/hooks/useHotkeys";

import { IButtonProps } from "./Toolbar";
import ToolbarButton from "./ToolbarButton";

const UndoButton: React.FC<IButtonProps> = ({ icon, mode, title = "Undo" }) => {
  const { canUndo, undo } = useHistory(HistoryContext);
  const isDisabled =
    !canUndo || (!!mode && !["simple_select", "direct_select", "static", "draw_point", "draw_line_string", "draw_polygon"].includes(mode));

  useHotkeys({
    action: "UNDO",
    callback: (event) => {
      event.preventDefault();
      undo();
    },
    enabled: !isDisabled,
  });

  const handleOnClick = () => {
    undo();
  };

  const tooltipTitle = `${title} (${getHotkeyLabel("UNDO")})`;

  return (
    <ToolbarButton title={tooltipTitle} onClick={handleOnClick} disabled={isDisabled} data-testid="toolbar-undo-button">
      {icon || <Undo />}
    </ToolbarButton>
  );
};

export default UndoButton;
